import {ComplianceManagerApi} from "../../compliance-manager";
import {Col, Descriptions, Row, Typography} from "antd";
import React from "react";
import {QCResultWithData} from "../../../../isn/QCResult";
import ComplianceStatusButton from "../../../compliance-status-button";
import {ProviderType} from "../../../../../__generated__/graphql/types";
import {momentOrNull} from "../../../../../common/util";
import useBreakpoints from "../../../../../hooks/useBreakpoints";
import ISNChecker from "../../../../ISNChecker";
import {NextExpirationDate} from "../../../NextExpirationDate";

/**
 * Tab for displaying ISN result details. Simply reuses the existing IsnDetails component.
 */
export default function IsnTab(props: { api: ComplianceManagerApi }){

    const bp = useBreakpoints();

    const { api } = props;

    const isSmallScreen = bp.max("medium");

    const isnProviderResult = api.complianceResult?.isnProviderResult;
    const hasError = !!isnProviderResult?.error;

    function renderIsnResult(){
        if (api.paxContext?.paxNode?._id){
            return <QCResultWithData
                paxId={api.paxContext.paxNode._id}
                fetchPolicy="cache-and-network"
                onResultUpdated={api.refetchPaxNode}
            />
        }
        else if (api.paxContext.isnID && api.paxContext.customerID) {
            return <ISNChecker customerID={api.paxContext.customerID} isnNumber={api.paxContext.isnID} />
        }

        return null;
    }

    return <div style={{ marginTop: 12 }}>
        <Row style={{marginTop: "1.5rem", marginBottom: "1rem"}} type="flex" gutter={12}>
            {api.paxContext?.lastName ||api.paxContext?.firstName ? (
                <Col>
                    <h4>ISN Details for <span style={{textTransform: 'capitalize'}}>{api.paxContext?.lastName}</span>, <span style={{textTransform: 'capitalize'}} >{api.paxContext?.firstName}</span></h4>
                </Col>
            ) : null}
        </Row>
        <Descriptions
            className="mc-compliance-manager-details"
            bordered
            column={1}
            size="small"
            layout={isSmallScreen ? 'vertical' : 'horizontal'}
            style={{ marginBottom: 12 }}
        >
            <Descriptions.Item label="Status">
                <ComplianceStatusButton
                    pax={api.paxContext}
                    disabled
                    showSourcesTooltip={false}
                    selectedProvider={ProviderType.ISN}
                />
            </Descriptions.Item>
            <Descriptions.Item label="ISN Quick Check Status">
                {isnProviderResult?._isnResult?.selectedResult?.quickCheckStatus}
            </Descriptions.Item>
            <Descriptions.Item label="ISN ID">
                {isnProviderResult?._isnResult?.selectedResult?.isnId}
            </Descriptions.Item>
            <Descriptions.Item label="Reason">
                {isnProviderResult?.reason}
            </Descriptions.Item>
            <Descriptions.Item label="Last Check Time">
                {momentOrNull(isnProviderResult?.startTs)?.format('YYYY-MM-DD HH:MM')}
            </Descriptions.Item>
            {!!isnProviderResult?.nextExpirationDate && (
                <Descriptions.Item label="Next Expiration">
                    <NextExpirationDate date={isnProviderResult.nextExpirationDate} />
                    {' '}
                    {isnProviderResult?.nextExpirationQualificationName ? `(${isnProviderResult?.nextExpirationQualificationName})` : ''}
                </Descriptions.Item>
            )}
            {hasError ? (
                <Descriptions.Item label="Error Message" className="mc-compliance-manager-error">
                    <Typography.Text type="danger">{isnProviderResult?.error}</Typography.Text>
                </Descriptions.Item>
            ) : null}
            <Descriptions.Item label="Duration">
                {isnProviderResult?.latencyMs} ms
            </Descriptions.Item>
        </Descriptions>
        {renderIsnResult()}
    </div>

    // return <IsnDetails
    //     id={paxID}
    //     extra={
    //         <ComplianceSwitcherButton
    //             paxID={paxID}
    //             targetSource={ComplianceSource.ISN}
    //             style={{ marginLeft: 12 }}
    //         />
    //     }
    // />
}